<template>
  <div class="small text-muted-more">{{ $t('LoanApplicationTimeline.verificationIsDone') }}</div>
</template>
<script>
export default {
  name: 'IdentityVerificationDoneComponent'
}
</script>
